var map = {
	"./Academy_icon.svg": 37145,
	"./AllMarkets.svg": 4932,
	"./Anyswap.png": 55947,
	"./Anyswap.svg": 55152,
	"./Arrow.svg": 67639,
	"./ArrowBottom.svg": 38893,
	"./ArrowConnect.svg": 54509,
	"./ArrowConnectTwo.svg": 14793,
	"./ArrowRight.svg": 84402,
	"./ArrowSmall.svg": 49446,
	"./ArrowUp.svg": 90359,
	"./Artwork.svg": 56287,
	"./Artwork_gmx.svg": 10641,
	"./Axelar.svg": 88221,
	"./BackArrow.svg": 98278,
	"./Banxa.png": 15194,
	"./BearishArrow.svg": 562,
	"./Blog_icon.svg": 24755,
	"./BullishArrow.svg": 76362,
	"./CloseIcon.svg": 33493,
	"./Collapse.svg": 58132,
	"./Colleteral.svg": 59659,
	"./ConvertIconEvent.png": 42851,
	"./Discord_icon.svg": 81471,
	"./Docs_icon.svg": 28102,
	"./Dots.svg": 86606,
	"./DownloadCSV.svg": 72509,
	"./EarnIconEvent.png": 70273,
	"./EventTitleArrow1.svg": 8131,
	"./EventTitleArrow2.svg": 85589,
	"./EventTitleArrow3.svg": 3526,
	"./Exchnage_swap_event_arrow.svg": 69611,
	"./Filtericon.svg": 88545,
	"./Fox_Logo.svg": 64162,
	"./Fox_Logo_Black.svg": 81866,
	"./Fox_token.png": 84897,
	"./FoxifyDocs.svg": 10640,
	"./FoxifyLogo.svg": 73744,
	"./Foxify_Logo.svg": 31307,
	"./Foxify_Ranks.png": 40988,
	"./Foxify_Ranks_0.png": 11663,
	"./Foxify_Ranks_1.png": 60425,
	"./Foxify_Ranks_2.png": 70078,
	"./Foxify_Ranks_3.png": 42083,
	"./Foxify_Ranks_4.png": 28915,
	"./GasPreference.svg": 17118,
	"./GiveGetIcon.png": 69758,
	"./History.svg": 13477,
	"./Hop.png": 79577,
	"./Hop.svg": 68415,
	"./Hop_dark.png": 20815,
	"./Hop_dark.svg": 45106,
	"./Language.svg": 63135,
	"./LongIcon.svg": 45047,
	"./MEXCLogo.png": 56640,
	"./MenuIcon.svg": 48828,
	"./MoonIcon.svg": 23279,
	"./NewUserIcon.png": 37202,
	"./No-position-order.png": 16306,
	"./No-position-order.svg": 99640,
	"./Orders.svg": 25646,
	"./Overview.svg": 87567,
	"./PaginationLeft.svg": 61504,
	"./PaginationRight.svg": 61842,
	"./PalmToken.svg": 39392,
	"./PalmTokenWhite.svg": 34854,
	"./Palm_Icon_Event.png": 58873,
	"./PancakeSwapLogo.png": 8862,
	"./Position.svg": 17576,
	"./RefferIcon.png": 26917,
	"./ShareArrow.svg": 83806,
	"./ShortIcon.svg": 74652,
	"./Squid.svg": 20138,
	"./Stake-card-arrow-third.svg": 25507,
	"./SunIcon.svg": 32130,
	"./Synapse.png": 3935,
	"./Synapse.svg": 73391,
	"./T2EBackground.png": 66323,
	"./T2EBackgroundDark.png": 25891,
	"./Telegram_icon.svg": 76139,
	"./ThemeSettings.svg": 56650,
	"./TotalTrades.svg": 49567,
	"./TotalVolume.svg": 53906,
	"./TradeIconEvent.png": 70073,
	"./TradingSettings.svg": 81744,
	"./Twitter_icon.svg": 62910,
	"./USDC.svg": 30217,
	"./UpDownIcon.svg": 94670,
	"./VersionIcon.svg": 62006,
	"./WalletIcon.svg": 16902,
	"./WeeklyDistributionIcon.png": 73293,
	"./arrowDownWhite.svg": 19112,
	"./benefit1.png": 52849,
	"./benefit2.png": 32129,
	"./benefit3.png": 98207,
	"./benefit4.png": 69556,
	"./benefit5.png": 57972,
	"./binance.png": 66030,
	"./bitkeep.svg": 42267,
	"./bridge.svg": 24232,
	"./bridgeIcon.svg": 15730,
	"./bridgeIconOrange.svg": 13642,
	"./bscscan.png": 81128,
	"./btn_big_arbitrum.png": 70756,
	"./btn_big_avalanche.png": 11784,
	"./btn_big_bsc.png": 74872,
	"./btn_big_purchasegmx.png": 43760,
	"./btn_big_purchasegmx.svg": 12346,
	"./buy_gmx.svg": 59709,
	"./buy_gmx_bond.svg": 17868,
	"./buy_transfer_eth.svg": 66961,
	"./checked.png": 720,
	"./coinbaseWallet.png": 32346,
	"./coingecko.png": 64993,
	"./connectWalletInactive.svg": 82386,
	"./connectWalletMobile.svg": 16103,
	"./cross.svg": 77150,
	"./docsOrange.svg": 80689,
	"./draggable.svg": 78646,
	"./favicon.ico": 60244,
	"./favicon.svg": 55608,
	"./favoriteActive.svg": 60593,
	"./favoriteInactive.svg": 53406,
	"./flag_de.svg": 10192,
	"./flag_en.svg": 49124,
	"./flag_es.svg": 95372,
	"./flag_fr.svg": 60839,
	"./flag_ja.svg": 44850,
	"./flag_ko.svg": 85160,
	"./flag_ru.svg": 76176,
	"./flag_zh.svg": 85896,
	"./fullScreen.svg": 80362,
	"./funded_trading.png": 7309,
	"./gasSymbol.svg": 20965,
	"./gateio.svg": 33610,
	"./glp_icon.svg": 3689,
	"./graphite-01.png": 26020,
	"./ic_arrowleft16.svg": 71774,
	"./ic_arrowright16.svg": 95143,
	"./ic_banxa.svg": 75136,
	"./ic_binance.svg": 57424,
	"./ic_binance_logo.svg": 85685,
	"./ic_bondprotocol_arbitrum.svg": 39016,
	"./ic_bsc.svg": 1088,
	"./ic_bungee.png": 58595,
	"./ic_buy_glp.svg": 9333,
	"./ic_bybit.svg": 37557,
	"./ic_cash.png": 33795,
	"./ic_cash.svg": 42531,
	"./ic_checked.svg": 21019,
	"./ic_coingecko_16.svg": 85613,
	"./ic_coingecko_hover_16.svg": 29277,
	"./ic_convert_down.svg": 34935,
	"./ic_copy_16.svg": 15603,
	"./ic_cost.svg": 97906,
	"./ic_discord.svg": 21797,
	"./ic_dodo.svg": 13394,
	"./ic_firebird.png": 83041,
	"./ic_github.svg": 27467,
	"./ic_hop.svg": 86934,
	"./ic_huobi.svg": 94052,
	"./ic_info.svg": 38628,
	"./ic_kucoin.svg": 9039,
	"./ic_kyberswap.svg": 22502,
	"./ic_language24.svg": 71085,
	"./ic_link_40.svg": 79529,
	"./ic_liquidity.svg": 76738,
	"./ic_matcha.png": 71243,
	"./ic_medium.svg": 57488,
	"./ic_menu_dots.svg": 64337,
	"./ic_metamask_16.svg": 31356,
	"./ic_metamask_hover_16.svg": 68177,
	"./ic_multiswap.svg": 49215,
	"./ic_new_link_16.svg": 60613,
	"./ic_o3.png": 36666,
	"./ic_odos.png": 82284,
	"./ic_olympus.svg": 39219,
	"./ic_olympus_arbitrum.svg": 17682,
	"./ic_openocean.svg": 87132,
	"./ic_paraswap.svg": 35071,
	"./ic_selector_dropdowns.svg": 31370,
	"./ic_settings_16.svg": 88317,
	"./ic_settings_24.svg": 94240,
	"./ic_sign in_16.svg": 37516,
	"./ic_sign_out_16.svg": 98741,
	"./ic_simpleswaps.svg": 50240,
	"./ic_slingshot.svg": 93149,
	"./ic_stats.svg": 98865,
	"./ic_stats_big.svg": 39236,
	"./ic_synapse.svg": 56993,
	"./ic_tansak.svg": 61856,
	"./ic_telegram.svg": 50933,
	"./ic_tether_24.svg": 8466,
	"./ic_tokens.svg": 12870,
	"./ic_totaluser.svg": 26141,
	"./ic_trading.svg": 35095,
	"./ic_transfer_avax.svg": 54478,
	"./ic_twitter.svg": 16396,
	"./ic_wallet_24.svg": 75395,
	"./leader_1.svg": 90497,
	"./leader_2.svg": 70378,
	"./leader_3.svg": 24554,
	"./lg_arbitrum.svg": 96276,
	"./logo.png": 81053,
	"./logo_palm_share.svg": 58179,
	"./logo_palmswap.svg": 38482,
	"./long.svg": 54905,
	"./marketDetailsIcon.svg": 56188,
	"./metamask-text.svg": 78232,
	"./metamask.png": 46521,
	"./nansen_portfolio.svg": 73345,
	"./nft.png": 74583,
	"./page-not-found.svg": 39014,
	"./pancake.png": 91879,
	"./perpetualTutorialIcon.svg": 76997,
	"./places/Bronze.svg": 37107,
	"./places/Gold.svg": 13882,
	"./places/Silver.svg": 92241,
	"./playIcon.svg": 29192,
	"./plpIcon.png": 86631,
	"./plpToken.png": 53688,
	"./position-share-bg.jpg": 17009,
	"./reset.svg": 51090,
	"./ruelstable.png": 75851,
	"./searchSymbol.svg": 15644,
	"./settings.svg": 10313,
	"./shevron-down-chart.svg": 38550,
	"./shevron-down-circle.svg": 40529,
	"./shevron-down.svg": 3782,
	"./short.svg": 28800,
	"./success-tip.svg": 38869,
	"./swapCurrency.svg": 58232,
	"./tetherIcon.png": 4654,
	"./tether_usdt_logo.svg": 27130,
	"./trade_event_arrow_left_down.svg": 62505,
	"./trade_event_arrow_left_up.svg": 49989,
	"./trade_event_arrow_right.svg": 92908,
	"./trade_event_total_participants.png": 7795,
	"./trading.jpg": 30393,
	"./wallet-connect-text.svg": 51812,
	"./walletconnect-circle-blue.svg": 68891,
	"./wave-01.png": 49338,
	"./wave-02.png": 55046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;